<template>
  <ul class="stat-list">
  
    <li v-for="(item, index) in declaration" 
        v-bind:key="index">
        <h2 class="no-margins ">{{item.total}}</h2>
        <small>{{item.title}}</small>
        <div class="stat-percent">{{item.percent}}% <i class="fa fa-level-down text-navy"></i></div>
        <div class="progress progress-mini">
            <div :style="{width: `${item.percent}%`}" class="progress-bar"></div>
        </div>
    </li>
  </ul>
</template>
<script>

export default {
    data() {
        return {
            
        }
    },
    props:{
        declaration:{
            type: Array
        }
    },

    created(){

    },
    methods:{
     
    }
}

</script>